module.exports = __webpack_public_path__ + "img/checked.a03ac648.svg";